import React, { Component } from "react"
import Modal from "react-responsive-modal"
import { URL } from "../../store/actions/depannageActions"
import * as Addons from "../../utilities/Addons"

// Conteneurs vidéo lisibles nativement par le navigateur (mp4 Android, mov iOS).
export const VIDEO_EXTS = ["mp4", "mov", "m4v", "webm"]

export class FileDisplayer extends Component {
	constructor(props) {
		super(props)
		this.state = {
			file: {},
		}
	}

	componentDidMount = () => {
		const { extra, file } = this.props
		if (extra.ext === "pdf") {
			if (extra.saved) this.openPdf(`${URL}${file.url.substring(1)}`)
		} else if (VIDEO_EXTS.includes(extra.ext)) {
			this.setState({
				file: {
					width: window.screen.width - 300,
					height: window.screen.height - 300,
				},
			})
		} else {
			if (extra.saved) {
				let { width, height } = Addons.resizeImage(
					file.width,
					file.height,
					window.screen.width - 300,
					window.screen.height - 300,
				)
				this.setState({ file: { width, height } })
			} else {
				let img = new Image()
				let that = this
				img.onload = function () {
					let { width, height } = Addons.resizeImage(
						img.width,
						img.height,
						window.screen.width - 300,
						window.screen.height - 300,
					)
					that.setState({ file: { width, height, src: file.src } })
				}
				img.src = file.src
			}
		}
	}

	openPdf = (url) => {
		window.open(url)
		this.props.closeModal()
	}

	render() {
		const { file, extra } = this.props
		const url = extra.saved
			? `${URL}${file.url.substring(1)}`
			: this.state.file.src
		return (
			<Modal
				center={true}
				focusTrapped={false}
				open={this.props.visible}
				onClose={this.props.closeModal}
				showCloseIcon={false}
				classNames={{ overlay: "overlay", modal: "no-max-width" }}
			>
				{VIDEO_EXTS.includes(extra.ext) ? (
					// src direct (sans <source type>) : le navigateur détecte le
					// conteneur lui-même (nécessaire pour lire un .mov iOS).
					<video
						style={{
							maxWidth: this.state.file.width,
							maxHeight: this.state.file.height,
						}}
						src={`${URL}${file.url.substring(1)}`}
						controls
					/>
				) : extra.ext !== "pdf" ? (
					<img
						src={url}
						alt=""
						width={this.state.file.width}
						height={this.state.file.height}
					/>
				) : extra.saved ? null : (
					<h2 className="info">Sauvegarder pour avoir un aperçu</h2>
				)}
			</Modal>
		)
	}
}

export default FileDisplayer
